import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import {map} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {CompanySandbox} from '../../../modules/global';
import { PageContainerComponent } from '../../../modules/shared/components/page-container/page-container.component';
import { TitledCardComponent } from '../../../modules/shared/components/titled-card/titled-card.component';
import { SvgIconComponent } from 'angular-svg-icon';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'slm-component-debt',
    templateUrl: './company-debt.container.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [PageContainerComponent, TitledCardComponent, SvgIconComponent, TranslateDirective, AsyncPipe, TranslatePipe]
})
export class CompanyDebtContainer implements OnInit {
  private readonly companySandbox = inject(CompanySandbox);

  public companyName$: Observable<string>;

  ngOnInit(): void {
    this.companyName$ = this.companySandbox.activeCompany$.pipe(
      map(company => company?.partnerName ? company.partnerName : '')
    );
  }
}
